import { Divider, Grid } from "@mui/material";
import { BarekamIcon, IconVariants } from "../../../pages/components/icon/barekam-icon";
import BarekamText from "../../../pages/components/text";
import logo from "../../../assets/logo.png";
import React from "react";
import { OrderModel } from "../../../pages/shared/models/order/order-item.model";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";
import { SimpleTable } from "../styled";
import moment from "moment/moment";
import { useAppSelector } from "../../../redux/store";

export const PolandExportTemplate = ({ order }: { order: OrderModel }) => {
    const { languageId } = useAppSelector(state => state.messagesReducer);

    const polandSender = {
        id: 'N/A',
        name: order?.shippingInfo?.warehouse?.name || '',
        address: order?.shippingInfo?.warehouse?.addressLine1 || '',
        postIndex: order?.shippingInfo?.warehouse?.zipCode || '',
        city: order?.shippingInfo?.warehouse?.city || '',
        country: order?.shippingInfo?.country?.name[4] || '',
        province: order?.shippingInfo?.warehouse?.state[languageId] || '',
        phone: order?.shippingInfo?.warehouse?.phone || ''
    }

    const receiver = {
        id: order.recipient?.relatedUser.addressLine2ForLand || '',
        name: `${order.recipient?.firstName} ${order.recipient?.lastName}`,
        address: `${order.recipient.region?.name[languageId] || ''}, ${order.recipient.street || ''}, ${order.recipient.building || ''} ${order.recipient.entrance ? ',' + order.recipient.entrance : ''} ${order.recipient.floor ? ', ' + order.recipient.floor : ''} ${order.recipient.apartment ? ', ' + order.recipient.apartment : ''}`,
        city: order.recipient.city?.name[languageId] || '',
        country: order.recipient.country?.name[languageId] || '',
        province: order.recipient.province?.name[languageId] || '',
        email: order.recipient?.email,
        phone: order.recipient?.phoneNumber
    }

    const Recipient = ({ id, name, address, postIndex, city, country, province, email, phone, isFrom }: RecipientProps) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {isFrom
                    ? <>
                        <div>From Name: {order.products[0]?.store?.name[languageId]}</div>
                        <Divider style={{ width: '100%' }} />
                    </>
                    : <>
                        <div>To ID: {id}</div>
                        <div>Name: {name}</div>
                        <Divider style={{ width: '100%' }} />
                    </>
                }

                <div>Address: {address}</div>
                <Divider style={{ width: '100%' }} />

                {postIndex
                    ? <>
                        <div>Post index: {postIndex}</div>
                        <Divider style={{ width: '100%' }} />
                    </>
                    : ''
                }

                <div>City/Province/Country:</div>
                <div>{`${city}/${province}/${country}`}</div>
                <Divider style={{ width: '100%' }} />

                {email && <div>Email: {email}</div>}
                <Divider style={{ width: '100%' }} />

                <div>Phone: {phone}</div>
                <Divider style={{ width: '100%' }} />
            </div>
        )
    }

    return (
        <Grid container width={'100%'} height={'100%'} padding={'3rem'} rowSpacing={'0.5rem'}>
            <Grid item xs={12} display={'flex'} justifyContent={"space-between"}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <BarekamIcon variant={IconVariants.globe} size={{ width: '1rem', height: '1rem' }} />
                    <BarekamText variant={'l'}>
                        www.barekam.am
                    </BarekamText>
                </div>

                <img className={"logo"}
                    src={logo}
                    style={{ height: '1.5rem' }}
                    alt={""} />
            </Grid>

            <Grid item xs={12}><Divider style={{ width: '100%' }} /></Grid>

            <Grid item xs={12} display={'flex'} flexDirection={'row'}>
                <div style={{ paddingRight: '0.5rem', width: '40%' }}>
                    <Recipient {...polandSender} isFrom />

                    <br />

                    {order.recipient
                        ? <Recipient {...receiver} />
                        : <Recipient id={''} name={''} address={''} postIndex={''} city={''} country={''} province={''} email={''} phone={''} />
                    }

                    <div>Date: {moment(order.enteredDate).format('YYYY-MM-DD')}</div>
                </div>

                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div style={{ width: '100%' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ zIndex: '-999' }}>
                                <Barcode height={40} width={1} value={order.internalTrackingNumber} />
                            </div>

                            <QRCode style={{ height: '5rem', width: '5rem' }}
                                value={"www.barekam.am/tracking/" + order.internalTrackingNumber} />
                        </div>

                        <SimpleTable>
                            <tbody>
                                <tr>
                                    <th><BarekamText variant={'s'}>Description<br />of<br />contents</BarekamText></th>
                                    <th><BarekamText variant={'s'}>Quantity</BarekamText></th>
                                    <th><BarekamText variant={'s'}>Gross (kg)</BarekamText></th>
                                    <th><BarekamText variant={'s'}>Value ({order.products[0]?.currency?.name[languageId]})</BarekamText></th>
                                </tr>
                                <tr>
                                    <td>{order.products[0]?.name}</td> 
                                    <td>1 pcs</td>
                                    <td>{order.weight} kg</td>
                                    <td>{order.products[0]?.price} {order.products[0]?.currency?.name[languageId]}</td>
                                </tr>
                            </tbody>
                        </SimpleTable>
                    </div>
                    <div style={{ marginTop: '40px', marginLeft: '20px' }}>
                        <Barcode height={250} width={3} value={order.internalTrackingNumber} />
                    </div>
                </div>
            </Grid>
        </Grid>
    )
}

interface RecipientProps {
    id: string,
    name: string,
    address?: string,
    postIndex?: string,
    city?: string,
    country?: string,
    province?: string,
    email?: string,
    phone?: string
    isFrom?: boolean
}